/*eslint-disable*/
import React from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { PropTypes } from "prop-types";

import poweredbylogo from "assets/img/api_logo_pwrdBy_strava_horiz_gray.png";
import logo from "assets/img/Original Logo.png";

import { Nav, NavLink as ReactstrapNavLink } from "reactstrap";
import {
  BackgroundColorContext,
  backgroundColors,
} from "contexts/BackgroundColorContext";

function Sidebar(props) {
  const location = useLocation();
  const [isExpanded, setIsExpanded] = React.useState(false);
  const expandTimer = React.useRef(null);

  // Use the sidebarOpened prop from Admin.js for mobile state
  const isMobileOpen = props.sidebarOpened || false;

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  // Smooth hover expand with small delay to prevent flicker
  const handleMouseEnter = () => {
    clearTimeout(expandTimer.current);
    expandTimer.current = setTimeout(() => setIsExpanded(true), 80);
  };

  const handleMouseLeave = () => {
    clearTimeout(expandTimer.current);
    expandTimer.current = setTimeout(() => setIsExpanded(false), 200);
  };

  // Close mobile nav on route change
  React.useEffect(() => {
    if (isMobileOpen && props.toggleSidebar) {
      props.toggleSidebar();
    }
  }, [location]);

  // Clean up timer
  React.useEffect(() => {
    return () => clearTimeout(expandTimer.current);
  }, []);

  const closeMobile = () => {
    if (props.toggleSidebar && isMobileOpen) {
      props.toggleSidebar();
    }
  };

  const linkOnClick = () => {
    document.documentElement.classList.remove("nav-open");
    closeMobile();
  };

  const { routes, rtlActive } = props;

  // Icon mapping for each route 
  const getIcon = (iconClass) => {
    return <i className={iconClass} />;
  };

  return (
    <BackgroundColorContext.Consumer>
      {({ color }) => (
        <>
          {/* ─── COCKPIT RAIL (Desktop) ─── */}
          <div
            className={`cockpit-rail ${isExpanded ? "cockpit-rail--expanded" : ""}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {/* Logo Mark */}
            <div className="cockpit-rail__logo">
              <Link to="/admin/features" onClick={linkOnClick}>
                <img src={logo} alt="Iron Drive Stats" className="cockpit-rail__logo-img" />
              </Link>
            </div>

            {/* Navigation Items */}
            <nav className="cockpit-rail__nav">
              {routes.map((prop, key) => {
                if (prop.redirect) return null;
                const isActive = activeRoute(prop.layout + prop.path);
                return (
                  <NavLink
                    to={prop.layout + prop.path}
                    className={`cockpit-rail__item ${isActive}`}
                    key={key}
                    onClick={linkOnClick}
                    title={prop.name}
                  >
                    <span className="cockpit-rail__icon">
                      {getIcon(prop.icon)}
                    </span>
                    <span className="cockpit-rail__label">
                      {rtlActive ? prop.rtlName : prop.name}
                    </span>
                  </NavLink>
                );
              })}
            </nav>

            {/* Bottom: Powered by Strava */}
            <div className="cockpit-rail__footer">
              <img src={poweredbylogo} alt="Powered by Strava" className="cockpit-rail__strava" />
            </div>
          </div>

          {/* ─── Glassmorphism Overlay (when expanded) ─── */}
          {isExpanded && (
            <div
              className="cockpit-rail__backdrop"
              onClick={() => setIsExpanded(false)}
            />
          )}

          {/* ─── MOBILE OVERLAY NAV ─── */}
          {isMobileOpen && (
            <div className="cockpit-mobile-overlay" onClick={closeMobile}>
              <div className="cockpit-mobile-panel" onClick={(e) => e.stopPropagation()}>
                <div className="cockpit-mobile-header">
                  <img src={logo} alt="Iron Drive Stats" />
                  <button className="cockpit-mobile-close" onClick={closeMobile}>
                    <i className="tim-icons icon-simple-remove" />
                  </button>
                </div>
                <nav className="cockpit-mobile-nav">
                  {routes.map((prop, key) => {
                    if (prop.redirect) return null;
                    return (
                      <NavLink
                        to={prop.layout + prop.path}
                        className={`cockpit-mobile-item ${activeRoute(prop.layout + prop.path)}`}
                        key={key}
                        onClick={linkOnClick}
                      >
                        <i className={prop.icon} />
                        <span>{rtlActive ? prop.rtlName : prop.name}</span>
                      </NavLink>
                    );
                  })}
                </nav>
                <div className="cockpit-mobile-footer">
                  <img src={poweredbylogo} alt="Powered by Strava" />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </BackgroundColorContext.Consumer>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    text: PropTypes.node,
    imgSrc: PropTypes.string,
  }),
};

export default Sidebar;
